const RiskProfitTable = require('okCharts/RiskProfitTable');

module.exports = RiskProfitTable;
